import { useState } from 'react'
import FormErrors from '../components/FormErrors'
import { signUp } from '../lib/allauth'
import { Link } from 'react-router-dom'
import { useConfig } from '../auth'
import ProviderList from '../socialaccount/ProviderList'
import { Card, Input, Button, Typography, Divider, Space } from 'antd'

const { Title, Text } = Typography

export default function Signup () {
  const [email, setEmail] = useState('')
  const [password1, setPassword1] = useState('')
  const [password2, setPassword2] = useState('')
  const [password2Errors, setPassword2Errors] = useState([])
  const [response, setResponse] = useState({ fetching: false, content: null })
  const config = useConfig()
  const hasProviders = config.data.socialaccount?.providers?.length > 0

  function submit () {
    if (password2 !== password1) { setPassword2Errors([{ param: 'password2', message: 'Password does not match.' }]); return }
    setPassword2Errors([])
    setResponse({ ...response, fetching: true })
    signUp({ email, password: password1 }).then((content) => { setResponse((r) => { return { ...r, content } }) }).catch((e) => { console.error(e); window.alert(e) }).then(() => { setResponse((r) => { return { ...r, fetching: false } }) })
  }

  return (
    <div style={{ maxWidth: 380, margin: '48px auto' }}>
      <Card>
        <Title level={2} className='tti-page-title' style={{ marginBottom: 4 }}>Sign Up</Title>
        <Text type='secondary' style={{ fontSize: 13 }}>Already have an account? <Link to='/account/login'>Login here.</Link></Text>
        <FormErrors errors={response.content?.errors} />
        <div style={{ marginTop: 20 }}>
          <label style={{ fontSize: 12, color: 'var(--tti-muted)' }}>Email</label>
          <Input value={email} onChange={(e) => setEmail(e.target.value)} type='email' style={{ marginTop: 4 }} />
          <FormErrors param='email' errors={response.content?.errors} />
        </div>
        <div style={{ marginTop: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--tti-muted)' }}>Password</label>
          <Input.Password autoComplete='new-password' value={password1} onChange={(e) => setPassword1(e.target.value)} style={{ marginTop: 4 }} />
          <FormErrors param='password' errors={response.content?.errors} />
        </div>
        <div style={{ marginTop: 12 }}>
          <label style={{ fontSize: 12, color: 'var(--tti-muted)' }}>Password (again)</label>
          <Input.Password value={password2} onChange={(e) => setPassword2(e.target.value)} style={{ marginTop: 4 }} />
          <FormErrors param='password2' errors={password2Errors} />
        </div>
        <Space direction='vertical' style={{ width: '100%', marginTop: 20 }} size='small'>
          <Button type='primary' block loading={response.fetching} onClick={() => submit()}>Sign Up</Button>
          {/*<Link to='/account/signup/passkey'><Button block size='small'>Sign up using a passkey</Button></Link>*/}
        </Space>
        {hasProviders && (<><Divider plain style={{ fontSize: 12 }}>or</Divider><ProviderList callbackURL='/account/provider/callback' /></>)}
      </Card>
    </div>
  )
}
